module.exports = __webpack_public_path__ + "img/accident.3b26bfb4.jpg";